import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, Box, CircularProgress, Stack } from '@mui/material';

const getRealizadoColor = (valor) => {
  if (typeof valor !== 'number') return 'default';
  if (valor >= 100) return 'success';
  if (valor >= 80) return 'warning';
  return 'error';
};

const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '--';
  return Math.round(Number(value)).toLocaleString('pt-BR');
};

const DisponibilidadeTurnoContratosTable = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  const sorted = [...data].sort((a, b) => {
    const aVal = typeof a.percentual_realizado === 'number' ? a.percentual_realizado : -Infinity;
    const bVal = typeof b.percentual_realizado === 'number' ? b.percentual_realizado : -Infinity;
    return bVal - aVal; // maior % primeiro
  });

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Disponibilidade de Turno
        </Typography>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center', width: 80 }}>Ranking</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Contrato</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'right' }}>Turnos Previstos</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'right' }}>Turnos Abertos</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            sorted.map((row, idx) => {
              const rank = idx + 1;
              let rankColor = undefined;
              if (idx === 0 || idx === 1 || idx === 2) rankColor = 'success.main';
              else if (idx >= 3 && idx <= 6) rankColor = 'warning.main';
              else if (idx >= 7) rankColor = 'error.main';
              const previsto = row.total_previsto ?? row.total_previstos ?? row.meta_prevista;
              const realizado = row.total_aberto ?? row.total_realizado ?? row.producao_realizada;
              const percentual = typeof row.percentual_realizado === 'number' ? Math.round(row.percentual_realizado) : null;
              return (
                <TableRow key={row.des_contrato || idx} hover>
                  <TableCell align="center" sx={{ fontWeight: 700, fontSize: 18, color: rankColor }}>{rank}</TableCell>
                  <TableCell>{row.des_contrato}</TableCell>
                  <TableCell align="right">{formatNumber(previsto)}</TableCell>
                  <TableCell align="right">{formatNumber(realizado)}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={percentual !== null ? `${percentual}%` : '--'}
                      color={getRealizadoColor(percentual)}
                      size="small"
                      sx={{ fontWeight: 700, minWidth: 70 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DisponibilidadeTurnoContratosTable;


